import './App.css';

import { Outlet, useMatches } from '@tanstack/react-router';

import { MainLayout } from './components/layout';
import { AppProvider } from './providers';
import { ROUTE_CONSTANTS } from './routes';

function App() {
  const matches = useMatches();
  const isLoginRoute = matches.some((match) => match.routeId === ROUTE_CONSTANTS.LOGIN_PATH);

  return <AppProvider>{isLoginRoute ? <Outlet /> : <MainLayout />}</AppProvider>;
}

export default App;
